<div class="tt-o-pinboard-media">
  <img :src="imageSrc" class="tt-o-pinboard-media__image" :alt="altText">
  <time v-if="media.durationFormatted" class="tt-o-pinboard-media__video-timestamp">{{ media.durationFormatted }}</time>
</div>
